import React from 'react';
import TechnicalFilm, { Film } from './TechnicalFilm';

const AGENT_SYSTEM: Film = {
    directory: 'agent-system',
    name: 'Inside an agent system',
    title: <>Inside an <em>agent system.</em></>,
    description: <>A short visual guide to <code>RETURN_CONTROL</code>: the agent chooses an action, your application executes it, and the result comes back.</>,
    seconds: 20,
    articleSlug: 'agentic-ai-salesforce',
    posterAlt: 'Opening frame: Useful autonomy needs a system, beside a connected dotted orb.',
    disclosure: 'Concept preview, not live agent activity.',
    captionsTestId: 'agent-film-captions',
    transcript: [
        { time: '0:00 to 0:04', text: 'Useful autonomy needs a system. The agent decides what; your application controls how.' },
        { time: '0:04 to 0:09', text: 'A request reaches the Bedrock Agent. It chooses an action and parameters. A decision is not yet an execution.' },
        { time: '0:09 to 0:14', text: <>With <code>RETURN_CONTROL</code>, your application calls Apex through the Salesforce REST API. Business logic stays in its own context.</> },
        { time: '0:14 to 0:20', text: 'Your application returns the result to the Bedrock Agent. The agent then generates the final answer. The agent reasons; your code executes.' },
    ],
};

export default function AgentSystemFilm({ inline = false }: { inline?: boolean }) {
    return <TechnicalFilm film={AGENT_SYSTEM} inline={inline} />;
}
